import React, { useState, useEffect, useRef } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const ScrollButton = ({ paginationRef }) => {
  const [position, setPosition] = useState('top'); // 'top', 'pagination', 'middle'

  // Handle scroll position tracking
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      const paginationTop = paginationRef?.current?.getBoundingClientRect()?.top + window.scrollY;

      if (scrollY < 100) {
        setPosition('top'); // At top
      } else if (paginationTop && scrollY + viewportHeight >= paginationTop - 100) {
        setPosition('pagination'); // Near pagination
      } else {
        setPosition('middle'); // In between
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, [paginationRef]);

  // Scroll actions
  const scrollToPagination = () => {
    if (paginationRef?.current) {
      const paginationTop = paginationRef.current.getBoundingClientRect().top + window.scrollY;
      const offset = 500; // Adjust this value as per your layout (try 100–150)

      window.scrollTo({
        top: paginationTop - offset,
        behavior: 'smooth',
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Hide if in middle

  return (
    <div className="fixed bottom-28 right-2 z-20 w-full max-w-xs mx-auto">
      <button
        aria-label="Scroll"
        onClick={position === 'top' ? scrollToPagination : scrollToTop}
        className="bg-[#4c0f2e] text-[#f4d9c4] p-3 sm:p-3 rounded-xl border border-[#f4d9c4] shadow-md
          hover:bg-[#4c0f2e] transition-all duration-300 ease-in-out
          flex items-center justify-center ml-auto"
      >
        {position === 'top' ? (
          <FaChevronDown className="w-3 h-3 sm:w-5 sm:h-5" />
        ) : (
          <FaChevronUp className="w-3 h-3 sm:w-5 sm:h-5" />
        )}
      </button>
    </div>
  );
};

export default ScrollButton;
